import {
  InsertionPosition,
  WidgetAutocheck,
  WidgetConfig,
  WidgetElementType,
} from "@redotech/redo-model/widget";
import { RedoToggleElement } from "../cart-app";
import { DEFAULT_RIC_PLACEMENT_SELECTOR } from "../selectors";
import { getCartShadowRoot } from "../utils";

type DocOrShadow = ShadowRoot | Document;

export function getReactElementFromPlacement({
  widgetConfig,
  autocheck,
}: {
  widgetConfig: WidgetConfig;
  autocheck: WidgetAutocheck;
}): Element[] {
  const shadowRoot = getCartShadowRoot(
    autocheck,
    widgetConfig.shadowRootSelector,
  );

  const docElements: DocOrShadow[] = [];

  if (shadowRoot) {
    docElements.push(shadowRoot);

    if (widgetConfig.placeInsideAndOutsideShadowRoot) {
      docElements.push(document);
    }
  } else {
    docElements.push(document);
  }

  const foundElements: Element[] = [];

  for (const ele of docElements) {
    foundElements.push(
      ...Array.from(
        ele.querySelectorAll(
          widgetConfig.placementSelector || DEFAULT_RIC_PLACEMENT_SELECTOR,
        ),
      ),
    );
  }

  return foundElements;
}

export function getPlacedRedoToggle({
  container,
  widgetConfig,
  anyRedoToggle,
}: {
  container: HTMLElement | Element | null;
  widgetConfig?: WidgetConfig;
  anyRedoToggle: boolean;
}): RedoToggleElement | undefined {
  if (!container) {
    return undefined;
  }

  if (anyRedoToggle) {
    return container?.querySelector(RedoToggleElement.TAG) as RedoToggleElement;
  }

  const toggles = container.querySelectorAll(RedoToggleElement.TAG) as
    | NodeListOf<RedoToggleElement>
    | undefined;

  if (toggles) {
    for (const toggleElement of toggles) {
      if (toggleElement.toggleClass === widgetConfig?.elementType) {
        return toggleElement;
      }
    }
  }

  return undefined;
}

export function widgetSortOrder(widget?: WidgetConfig): number {
  const widgetType: WidgetElementType | undefined = widget?.elementType;
  if (!widgetType) {
    return 0;
  }

  const sign = widget?.insertionPosition === InsertionPosition.APPEND ? -1 : 1;
  switch (widgetType) {
    case WidgetElementType.BOTH_CHECKOUT_BUTTONS:
      return 1 * sign;
    case WidgetElementType.INFO_CARD:
      return 2 * sign;
    case WidgetElementType.NON_COVERAGE_CHECKOUT_BUTTON:
      return 3 * sign;
    case WidgetElementType.COVERAGE_CHECKOUT_BUTTON:
      return 4 * sign;
  }
}
